import { useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "@/lib/auth-context";
import { safeNext } from "@/lib/safe-next";

// Global popup shown when the session ends on its own (idle timeout or a failed
// token refresh). Manual logout and direct logged-out visits never trigger it.
export default function SessionExpiredModal() {
  const { expired, dismissExpired } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (!expired) return null;

  const goLogin = () => {
    dismissExpired();
    // Carry the current path as `next` so the user returns to where they were after
    // re-logging in (safeNext drops it if it's already an auth page — no self-loop).
    const next = safeNext(location.pathname + location.search);
    navigate(`/login?next=${encodeURIComponent(next)}`);
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
    >
      <div className="w-full max-w-sm rounded-2xl border border-white/10 bg-neutral-900 p-6 text-center shadow-2xl">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/15 text-accent">
          <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
          </svg>
        </div>
        <h2 className="mt-4 font-display text-lg font-semibold text-text">Session expired</h2>
        <p className="mt-1.5 text-sm text-text/60">
          You were signed out after a period of inactivity. Please log in again to continue.
        </p>
        <button
          onClick={goLogin}
          className="mt-5 w-full rounded-lg bg-primary px-4 py-2.5 font-medium text-white transition hover:opacity-95"
        >
          Log in
        </button>
      </div>
    </div>
  );
}
